// extracted by mini-css-extract-plugin
module.exports = {"DocumentSectionTitle__addButton":"DocumentsPageTitle_DocumentSectionTitle__addButton__muUge","DocumentsPageTitle":"DocumentsPageTitle_DocumentsPageTitle__YdShq"};